// const { ajax } = require("jquery");

jQuery(document).ready(function($) {

    sessionTimer();
  
    /**
     * 'Continue my application' button click event
     */
    $('#continueMyApp').on('click', function() {
        clearInterval(MODAL_COUNTER);
        sessionTimer();
        $('#sessionTimeoutModal').modal('hide');
    });

    /**
     * Countdown for session timeout (9mins)
     */
    function sessionTimer() {
        // Check if timer modal exists
        if( $('#sessionTimeoutModal').length == 0 ) return;
  
        setTimeout(function(){
            startModalTimer();

            const sessionTimeoutModal = new bootstrap.Modal('#sessionTimeoutModal', {
                keyboard: false,
                backdrop: 'static',
                show: true
            });

            sessionTimeoutModal.show();
            return false;
           // 1200000
        }, 1200000);
    }
  
  
    function startModalTimer() {
        MODAL_COUNT = 30;
        MODAL_COUNTER = setInterval( modalTimer, 1100);
    }
  
    /**
     * Simple countdown that updates html in modal window
     */
    function modalTimer() {
        MODAL_COUNT = MODAL_COUNT-1;
        if (MODAL_COUNT < 0) {
            clearInterval(MODAL_COUNTER);
            

            $.ajax({
                url: '/timeout',
                type: 'POST',
                beforeSend: function(e) {
                    var btnHtml = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Please wait ...';
                    $('#continueMyApp').html(btnHtml).prop("disabled", true);
                },
                complete: function(e) {
                    // unblockElement(el);
                }
            }).done(function(response) {
                let status = parseInt(response.response_code);
                if(status == 1) {
                    window.location = '/info';
                    return;
                }
                window.location = '/apply';
            });
            
            return;
        }
        $('#sessionTimeoutModal .modal-timer > span').html(MODAL_COUNT);
    }

});